(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.section--faq').forEach(function(section) {
  var items = section.querySelectorAll('details.faq-item');
  items.forEach(function(item) {
    item.addEventListener('toggle', function() {
      if (!item.open) return;
      items.forEach(function(other) {
        if (other !== item && other.open) other.open = false;
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // Wait for browser to render, then calculate and set height
              requestAnimationFrame(() => {
                // Force reflow to ensure content is rendered
                void this.offsetHeight;

                // Use scrollHeight to get the natural height (works even when height is 0)
                const contentHeight = this.scrollHeight;

                // Set the calculated height (CSS transition will animate from 0 to this height)
                this.style.height = `${contentHeight}px`;

                // Count .card items and set --items-count on gridy-slider
                const cardItems = this.querySelectorAll('.card');
                const gridySlider = this.querySelector('gridy-slider');
                if (gridySlider && cardItems.length > 0) {
                  gridySlider.style.setProperty('--items-count', cardItems.length);
                }

                // After 2.5s, set height to auto
                setTimeout(() => {
                  this.style.height = 'auto';
                }, 2500);


              });
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
